/*
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-02-26 17:55:16
 * @LastEditTime: 2019-03-11 14:15:56
 */
const demo = () => import("@/views/home/demo"),
    homepage = () => import("@/views/home/HomePage"),
    preachingtour = () => import("@/views/CampusRecruitment/PreachingTour"),
    campusRecruitment = () =>
        import("@/views/socialRecruitment/campusRecruitment"),
    preachingDetails = () =>
        import("@/views/socialRecruitment/preachingDetails"),
    jobdetails = () => import("@/views/socialRecruitment/Jobdetails"),
    resume = () => import("@/views/PersonalCenter/resume"),
    resumezp = () => import("@/views/onlineResume/resumezp"),
    selection = () => import("@/views/onlineResume/selection"),
    schoolrecruitment = () =>
        import("@/views/socialRecruitment/schoolRecruitment"),
    environment = () => import("@/views/environment"),
    Curriculumvitae = () => import("@/views/onlineResume/Curriculumvitae"),
    collectrecord = () =>
        import("@/views/PersonalCenter/components/collectRecord"), //收藏记录
    accountsetting = () =>
        import("@/views/PersonalCenter/components/accountSetting"), //账号设置
    deliverrecord = () =>
        import("@/views/PersonalCenter/components/deliverRecord"), //投递记录
    talentrecruitment = () =>
        import("@/views/socialRecruitment/talentRecruitment");
// 默认路由
const baseRoute = [
    {
        path: "/",
        name: "homepage",
        component: homepage
    },
    {
        path: "/preachingtour",
        name: "preachingtour",
        component: preachingtour
    },
    {
        path: "/campusRecruitment",
        name: "campusRecruitment",
        component: campusRecruitment
    },
    {
        path: "/preachingDetails",
        name: "preachingDetails",
        component: preachingDetails
    },
    {
        path: "/talentrecruitment",
        name: "talentrecruitment",
        component: talentrecruitment
    },
    {
        path: "/schoolrecruitment",
        name: "schoolrecruitment",
        component: schoolrecruitment
    },
    {
        path: "/resume",
        name: "resume",
        component: resume
    },
    {
        path: "/resumezp",
        name: "resumezp",
        component: resumezp
    },
    {
        path: "/selection",
        name: "selection",
        component: selection
    },
    {
        path: "/jobdetails",
        name: "jobdetails",
        component: jobdetails
    },
    {
        path: "/environment",
        name: "environment",
        component: environment
    },
    {
        path: "/collectrecord",
        name: "collectrecord",
        component: collectrecord,
        meta: {
            auth: true
        }
    },
    {
        path: "/accountsetting",
        name: "accountsetting",
        component: accountsetting,
        meta: {
            auth: true
        }
    },
    {
        path: "/deliverrecord",
        name: "deliverrecord",
        component: deliverrecord,
        meta: {
            auth: true
        }
    },
    {
        path: "/Curriculumvitae",
        name: "Curriculumvitae",
        component: Curriculumvitae,
        meta: {
            auth: true
        }
    }
];

export default baseRoute;
